import { CheckCheck, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { UseConversationDetailsReturn } from "@/hooks/conversation/useConversationDetails";
import { ViewFullPageButton } from "./ViewFullPageButton";

interface ConversationDetailsActionsProps {
  state: UseConversationDetailsReturn;
  /**
   * When true (side-modal + insights panel mounts), prepend a chip that
   * deep-links to /genie-hub/conversations/:id. Stays off on the full-page
   * route itself so we don't render a button pointing at the current page.
   */
  showViewFullPageLink?: boolean;
}

/**
 * Mark Reviewed action button. Mounts in the side-modal's actionButton slot
 * AND in the full-page header. Identical UX in both. Analyze and the email
 * report live in the Actions tab (ConversationActionsTab).
 */
export function ConversationDetailsActions({
  state,
  showViewFullPageLink = false,
}: ConversationDetailsActionsProps) {
  const { currentConversation, reviewLoading, handleMarkAsReviewed } = state;

  const primaryColor = currentConversation?.agent?.branding?.primaryColor || "#4E9CFF";

  return (
    <div className="flex items-center gap-2">
      {showViewFullPageLink && currentConversation?.id && (
        <ViewFullPageButton
          conversationId={currentConversation.id}
          primaryColor={primaryColor}
        />
      )}
      {!currentConversation?.viewed && (
        <Button
          onClick={handleMarkAsReviewed}
          disabled={reviewLoading}
          className="text-white flex items-center gap-2 whitespace-nowrap text-xs sm:text-sm px-3 sm:px-4 py-2 disabled:opacity-50"
          style={{ backgroundColor: primaryColor, borderColor: primaryColor, opacity: reviewLoading ? 0.5 : 1 }}
          onMouseEnter={(e) => !e.currentTarget.disabled && (e.currentTarget.style.opacity = "0.8")}
          onMouseLeave={(e) => !e.currentTarget.disabled && (e.currentTarget.style.opacity = "1")}
        >
          {reviewLoading ? <Loader2 className="animate-spin h-4 w-4" /> : <CheckCheck className="h-4 w-4" />}
          <span>Mark Reviewed</span>
        </Button>
      )}
    </div>
  );
}
